export const STATUS_LABELS = {
  pendente: "Pendente",
  em_producao: "Em Produção",
  arte_aprovada: "Arte Aprovada",
  aguardando_arte: "Aguard. Arte",
  entregue: "Entregue",
  finalizado: "Finalizado",
  cancelado: "Cancelado",
};

function parseDateLocal(dateStr) {
  // Pure date strings (YYYY-MM-DD) are parsed as UTC by JS, causing a day offset
  // in negative UTC timezones (e.g. Brazil UTC-3). Append T12:00:00 to keep local.
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr))
    return new Date(dateStr + "T12:00:00");
  return new Date(dateStr);
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = parseDateLocal(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

// Data e hora (ex.: created_at): "25/09/2026 14:30".
export function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d)) return value;
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatCurrency(value) {
  if (value == null) return "—";
  const n = parseFloat(value);
  if (isNaN(n)) return "—";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(n);
}

// Data local no formato YYYY-MM-DD. toISOString() usa UTC e, depois das
// 21h no Brasil, já devolve o dia seguinte.
export function localISODate(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// "qui, 08/10/2026" — data com o dia da semana abreviado.
export function formatDateComDia(dateStr) {
  if (!dateStr) return "Sem data";
  const [a, m, d] = dateStr.slice(0, 10).split("-").map(Number);
  const dia = new Date(a, m - 1, d)
    .toLocaleDateString("pt-BR", { weekday: "short" })
    .replace(".", "");
  return `${dia}, ${formatDate(dateStr.slice(0, 10))}`;
}
